import VendorDealerLocationDataTable from "./VendorDealerLocationDataTable";

export default VendorDealerLocationDataTable;